import React, { useState, useEffect, useRef  } from "react"; 
import AOS from "aos"; // ✅ Import AOS
import { a } from "react-router-dom";
import "./home.css"; 
import { gsap } from "gsap";
import { TweenLite, Circ } from 'gsap';
import Typed from 'typed.js';
import { FaChevronDown } from "react-icons/fa";
// import { Accordion } from "react-bootstrap";
import "aos/dist/aos.css"; // Import AOS CSS
// import "bootstrap/dist/css/bopotstrap.min.css";
// import logo from '/my-app/public/img/CodeQlik_logo.png';
import team from '../../../img/team_img.png';
import case1 from '../../../img/FOTWW.png'; 
import case2 from '../../../img/Dakzy cover.png'; 
import case3 from '../../../img/girls slay cover.png';
import case4 from '../../../img/yacebazar.png';
import blog1 from '../../../img/blog-home-2.jpeg'
import blog2 from '../../../img/blog-home-new.jpeg';
import blog3 from '../../../img/blog-new.jpeg';
import logo1 from '../../../img/codeqlik_partner1.png';
import logo2 from '../../../img/codeqlik_partner10.PNG';
import logo3 from '../../../img/codeqlik_partner11.png';
import logo4 from '../../../img/codeqlik_partner12-removebg-preview.png';
import logo5 from '../../../img/codeqlik_partner2.png';
import logo6 from '../../../img/codeqlik_partner3.png';
import logo7 from '../../../img/codeqlik_partner4.png';
import logo8 from '../../../img/codeqlik_partner5-removebg-preview.png';
import logo9 from '../../../img/codeqlik_partner6.png';
import logo10 from '../../../img/codeqlik_partner7.jpeg';
import logo11 from '../../../img/codeqlik_partner8-removebg-preview.png';
import logo12 from '../../../img/logo-14.jpeg';
import logo13 from '../../../img/logo2.jpeg';
import logo14 from '../../../img/logo-3.jpeg';
import logo15 from '../../../img/logo-5.jpeg';
import logo16 from '../../../img/logo-4.jpeg';
import logo17 from '../../../img/logo13.jpeg';
import logo18 from '../../../img/codeqlik_partner1.png';
import review from '../../../img/download.jpeg';
import review2 from '../../../img/download2.jpeg';
import review3 from '../../../img/download3.jpeg';
import review4 from '../../../img/download4.jpeg';
 


function getDistance(p1, p2) {
  return Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2);
}

class Circle {
  constructor(pos, rad, color, ctx) {
    this.pos = pos;
    this.radius = rad;
    this.color = color;
    this.ctx = ctx;
    this.active = 0;
  }

  draw() {
    if (!this.active) return;
    this.ctx.beginPath();
    this.ctx.arc(this.pos.x, this.pos.y, this.radius, 0, 2 * Math.PI);
    this.ctx.fillStyle = `rgba(156,217,249,${this.active})`;
    this.ctx.fill();
  }
}


const imagesRow1 = [
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
  logo9,
  logo10,
  logo11,
  // Add more imports as needed, or import and add more images here
];
  
  const imagesRow2 = [
    logo12,
    logo13,
    logo14,
    logo15,
    logo16,
    logo17,
    logo18,
  ];
  const words = [
    "Customer Support",
    "Passion",
    "Positive Experience",
    "Trustworthiness",
    "Customer Focus",
    "Long-term Relation",
    "Innovation",
    "Collaboration",
    "Personalization",
    "Reliability",
    "Quality"
  ];
  

  const faqData = [
    {
      question: "What services does your company offer?",
      answer:
        "We offer a wide range of IT services, including website development, mobile app development, digital marketing, software development, staff augmentation, and UI/UX design."
    },
    {
      question: "Do you work with startups as well as established enterprises?",
      answer:
        "Yes, we cater to both startups and established businesses. Our flexible service models are designed to meet the specific needs of clients, regardless of their size."
    },
    {
      question: "Can you handle international projects?",
      answer:
        "Yes, we have experience working with clients globally, and we ensure seamless communication and project management across different time zones."
    },
    {
      question: "What platforms do you use for website development?",
      answer:
        "We develop websites using modern platforms and frameworks such as Laravel, CodeIgniter, Shopify, WordPress, and the MERN stack (MongoDB, Express.js, React, Node.js)."
    },
    {
      question: "Will the website be optimized for search engines (SEO)?",
      answer:
        "Yes, we ensure SEO optimization with proper meta tags, fast loading speeds, mobile responsiveness, and schema markup to improve search engine rankings."
    },
    {
      question: "Do you develop apps for both Android and iOS?",
      answer:
        "Yes, we develop native apps for both Android and iOS, as well as cross-platform apps using Flutter and React Native for faster development and lower costs."
    },
    {
      question: "How do you measure the success of digital marketing campaigns?",
      answer:
        "We use key performance indicators (KPIs) such as website traffic, conversion rates, click-through rates (CTR), and return on investment (ROI) to measure the success of our campaigns."
    }
  ];
  
  
  
  
function Homes() {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
      name: "",
      email: "",
      contact: "",
      message: "",
    });
  
    // Toggle modal visibility
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
  
    // Handle form input change
    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    };
  
    // Handle form submission
    const handleSubmit = (e) => {
      e.preventDefault();
      console.log("Form Data Submitted:", formData);
      handleClose(); // Close modal after submission
    };
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [showVideo, setShowVideo] = useState(false);
    const playButtonRef = useRef(null);

  // Only move play button within about-section

//   video modal///
const modalRef = useRef(null);

// Make sure you have this in App.js:
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const openVideo = () => setShowVideo(true);
const closeVideo = (e) => {
  e.stopPropagation();
  setShowVideo(false);
};
// slider//
const row1Ref = useRef(null);
  const row2Ref = useRef(null);

  useEffect(() => {
    const startInfiniteScroll = (ref, speed, direction) => {
      if (!ref.current) return;

      const inner = ref.current.querySelector(".slider-inner");
      const slides = Array.from(inner.children);

      // Clone slides for seamless effect
      slides.forEach((slide) => {
        let clone = slide.cloneNode(true);
        inner.appendChild(clone);
      });

      // Get total width dynamically
      let totalWidth = inner.scrollWidth / 2;

      gsap.set(inner, { x: direction === "left" ? "0%" : `-${totalWidth}px` });

      gsap.to(inner, {
        x: direction === "left" ? `-${totalWidth}px` : "0%",
        duration: speed,
        ease: "linear",
        repeat: -1,
      });
    };

    startInfiniteScroll(row1Ref, 30, "left");
    startInfiniteScroll(row2Ref, 30, "right");
  }, []);

//   circle//
const circleRef = useRef(null);

useEffect(() => {
  const animateWords = () => {
    const wordElements = document.querySelectorAll(".word");
    wordElements.forEach((word, index) => {
      setTimeout(() => {
        word.style.opacity = "1";
        word.style.transform = "translateY(0)";
      }, index * 300);
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateWords();
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  if (circleRef.current) {
    observer.observe(circleRef.current);
  }
}, []);



//   FAQ//
 
    
const [activeIndex, setActiveIndex] = useState(null);

const toggleAccordion = (index) => {
  setActiveIndex(activeIndex === index ? null : index);
};
// Fade Animation on scroll//
        useEffect(() => {
            AOS.init({ duration: 1000, once: true });
          }, []);






          // top heading animation
          const canvasRef = useRef(null);
          const headerRef = useRef(null);
          const points = useRef([]);
          const target = useRef({ x: window.innerWidth / 2, y: window.innerHeight / 2 });
        
          function getDistance(p1, p2) {
            return Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2);
          }
        
          class Circle {
            constructor(pos, rad, color, ctx) {
              this.pos = pos;
              this.radius = rad;
              this.color = color;
              this.ctx = ctx;
              this.active = 0;
            }
        
            draw() {
              if (!this.active) return;
              this.ctx.beginPath();
              this.ctx.arc(this.pos.x, this.pos.y, this.radius, 0, 2 * Math.PI);
              this.ctx.fillStyle = `rgba(156,217,249,${this.active})`;
              this.ctx.fill();
            }
          }
        
          useEffect(() => {
            let width = window.innerWidth;
            let height = window.innerHeight;
        
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');
            canvas.width = width;
            canvas.height = height;
        
            // Create points
            points.current = [];
            for (let x = 0; x < width; x += width / 20) {
              for (let y = 0; y < height; y += height / 20) {
                const px = x + (Math.random() * width) / 20;
                const py = y + (Math.random() * height) / 20;
                const p = { x: px, originX: px, y: py, originY: py };
                points.current.push(p);
              }
            }
        
            // Find closest points
            points.current.forEach(p1 => {
              p1.closest = points.current
                .filter(p2 => p1 !== p2)
                .sort((a, b) => getDistance(p1, a) - getDistance(p1, b))
                .slice(0, 5);
            });
        
            // Add circles
            points.current.forEach(p => {
              p.circle = new Circle(p, 2 + Math.random() * 2, 'rgba(255,255,255,0.3)', ctx);
            });
        
            function mouseMove(e) {
              target.current.x = e.clientX;
              target.current.y = e.clientY;
            }
        
            function resize() {
              width = window.innerWidth;
              height = document.body.scrollHeight;
              canvas.width = width;
              canvas.height = height;
            }
        
            function drawLines(p, ctx) {
              if (!p.active) return;
              p.closest.forEach(closestP => {
                ctx.beginPath();
                ctx.moveTo(p.x, p.y);
                ctx.lineTo(closestP.x, closestP.y);
                ctx.strokeStyle = `rgba(156,217,249,${p.active})`;
                ctx.stroke();
              });
            }
        
            function shiftPoint(p) {
              TweenLite.to(p, 1 + 1 * Math.random(), {
                x: p.originX - 50 + Math.random() * 100,
                y: p.originY - 50 + Math.random() * 100,
                ease: Circ.easeInOut,
                onComplete: () => shiftPoint(p),
              });
            }
        
            points.current.forEach(p => shiftPoint(p));
        
            function animate() {
              ctx.clearRect(0, 0, width, height);
              points.current.forEach(p => {
                const dist = getDistance(target.current, p);
                p.active = dist < 4000 ? 0.3 : dist < 20000 ? 0.1 : dist < 40000 ? 0.02 : 0;
                p.circle.active = p.active * 2;
                drawLines(p, ctx);
                p.circle.draw();
              });
              requestAnimationFrame(animate);
            }
        
            window.addEventListener('mousemove', mouseMove);
            window.addEventListener('resize', resize);
        
            animate();
        
            return () => {
              window.removeEventListener('mousemove', mouseMove);
              window.removeEventListener('resize', resize);
            };
          }, []);
            
            const el = useRef(null);
            const typed = useRef(null);
          
            useEffect(() => {
              typed.current = new Typed(el.current, {
                strings: [
                  '<span class="highlight">Digital</span> Innovation',
                  '<span class="highlight">Smart</span> Solutions',
                  '<span class="highlight">Future</span> Technology',
                  '<span class="highlight">Intelligent</span> Products',
                  '<span class="highlight">Creative</span> Software',
                  '<span class="highlight">Next-Gen</span> Platforms'
                ],
                typeSpeed: 60,
                backSpeed: 30,
                backDelay: 1500,
                loop: true,
                smartBackspace: false,
                showCursor: true
              });
          
              return () => typed.current.destroy();
            }, []);

  const aboutSectionRef = useRef(null);
  const handleSectionMouseMove = (e) => {
    const rect = aboutSectionRef.current.getBoundingClientRect();
    const button = playButtonRef.current;
    const buttonWidth = button ? button.offsetWidth : 100;
    const buttonHeight = button ? button.offsetHeight : 100;
    setPosition({
      x: e.clientX - rect.left - buttonWidth / 1,
      y: e.clientY - rect.top - buttonHeight / 1,
    });
  };

return (
    <div>
         <canvas
  ref={canvasRef}
  style={{
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: -1,
    width: '100%',
    height: '100%', // <-- CHANGED from 'auto' to '100%'
    pointerEvents: 'none', // Optional: ensures canvas doesn't block clicks
  }}
/>
      
      


<div
      id="large-header"
      ref={headerRef}
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        // backgroundImage:
        //   "url('https://www.marcoguglie.it/Codepen/AnimatedHeaderBg/demo-1/img/demo-1-bg.jpg')",
        zIndex: -2,
      }}
    >
    
    </div>
        <div className="hero ">
        <h1>
          Transforming<br /> Ideas into <br />
          <span ref={el} />
        </h1>
        <p>
          At CodeQlik, we blend design, sustainability & expertise to transform <br /> your vision with tech-driven
          precision. Elevate your projects with innovation.
        </p>

    <div className="hero-btn-row">
      {/* "Let's Connect" Button (Opens Modal) */}
      <a className="cta-button" onClick={handleShow}>
        Let's Connect <span className="arrow">↗</span>
      </a>
      
      <button id="talk-agent-btn" className="shiny-cta">
      Talk to Agent
      <span className="arrow heart">
        <img
          width="24"
          height="24"
          src="https://img.icons8.com/material-rounded/24/FFFFFF/microphone.png"
          alt="microphone"
        />
      </span>
    </button>
    </div>

      {/* Contact Modal */}
      {show && (
        <div className="modal fade show d-block custom-modal-overlay" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.35)', zIndex: 9999 }}>
          <div className="modal-dialog custom-modal-dialog" style={{ margin: '2rem auto', maxWidth: 420 }}>
            <div className="modal-content custom-modal-content" style={{ position: 'relative', padding: '32px 28px 24px 28px', borderRadius: 18, background: '#fff', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}>
              <button type="button" className="custom-modal-close" onClick={handleClose} aria-label="Close" style={{ position: 'absolute', top: 18, right: 18, background: 'none', border: 'none', fontSize: 22, color: '#888', cursor: 'pointer', zIndex: 2 }}>
                &#10005;
              </button>
              <div className="modal-headerA" style={{ borderBottom: 'none', paddingBottom: 0, marginBottom: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <h5 className="modal-title" style={{ fontSize: '1.5rem', fontWeight: 600, color: '#b2b2b2', margin: 0 }}>Contact Us</h5>
              </div>
              <div className="modal-bodyA" style={{ paddingTop: 0 }}>
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Name:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email:</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Contact Number:</label>
                    <input
                      type="tel"
                      className="form-control"
                      name="contact"
                      value={formData.contact}
                      onChange={handleChange}
                      placeholder="Enter your phone number"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Your Message:</label>
                    <textarea
                      className="form-control"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="3"
                      placeholder="Type your message here..."
                      required
                    ></textarea>
                  </div>
                  <button type="submit" className="btn btn-submit apply-job">Submit</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Overlay Effect */}
      {show && <div className="modal-backdrop fade show"></div>}
    </div> 
   
    <section>
      {/* About Section */}
      <div
        className="about-section"
        data-aos="fade-up"
        data-aos-delay="500"
        ref={aboutSectionRef}
        onMouseMove={handleSectionMouseMove}
        onClick={openVideo}
        style={{ position: "relative", cursor: "pointer" }}
      >
        <div className="background-gradient"></div>
        <div className="hexagon-container">
          <div className="hexagn">
            <img src={team} alt="Team" className="hex-image" />
          </div>
          <div
            className="circleA"
            ref={playButtonRef}
            style={{
              left: `${position.x}px`,
              top: `${position.y}px`,
              position: "absolute",
              zIndex: 9999,
              pointerEvents: "none"
            }}
          >
            <i className="fa-solid fa-play"></i>
            <div className="circle-textA">
              <svg viewBox="0 0 200 200">
                <defs>
                  <path
                    id="circlePathA"
                    d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
                  />
                </defs>
                <text>
                  <textPath href="#circlePathA">
                    KNOW ABOUT US ★ CODEQLIK IT SOLUTION ★ PLAY THE VIDEO ★
                  </textPath>
                </text>
              </svg>
            </div>
          </div>
        </div>
        {/* Marquee */}
        <marquee direction="left" behavior="scroll" scrollamount="7">
          Innovating with AI to empower industries Innovating with AI to empower industries
        </marquee>
        {/* Inline YouTube Video (shows when showVideo is true) */}
        {showVideo && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10000,
              background: "rgba(0,0,0,0.95)",
              borderRadius: 16,
              padding: 16,
              boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
            onClick={e => e.stopPropagation()}
          >
            <button
              onClick={closeVideo}
              style={{
                alignSelf: "flex-end",
                marginBottom: 8,
                background: "#1b1a1a",
                border: "none",
                borderRadius: 4,
                padding: "4px 12px",
                cursor: "pointer",
                fontWeight: 700
              }}
            >✕</button>
            <div style={{ width: 660, maxWidth: "90vw", aspectRatio: "16/9" }}>
              <iframe
                width="100%"
                height="415"
                src="https://www.youtube.com/embed/Eo0RzDoamxY?si=V2yOr1pPs2JS2QG2"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}
      </div> 

      
    </section>
    {/* <div style={styles.wrapper}>
      <canvas ref={particleCanvasRef} style={styles.canvas}></canvas>
      <div style={styles.content}>
        <h1 style={styles.title}>
          <a href="https://courses.mivja.com" target="_blank" rel="noopener noreferrer">Click Here</a>
        </h1>
        <p style={styles.subtitle}>*Move your mouse around*</p>
      </div>
    </div> */}
    <section>
      <div className="card-customA">
        <a href="/reviews">
          <h5 className="fw-bold">IT SOLUTIONS COMPANY</h5>
          <hr />
          <div className="d-flex">
            <div>
              <div className="d-flex justify-content-center my-3 profile-imagesA">
                <img src={review} alt="User 1" />
                <img src={review2} alt="User 2" />
                <img src={review3} alt="User 3" />
                <img src={review4} alt="User 4" />
              </div>
            </div>
            <div>
              <span className="starsA">★★★★★</span>
              <p className="mb-0">200+ 5 Star Reviews</p>
            </div>
          </div>
        </a>
      </div>

      <div className="container-fluid py-5">
        <div className="why mt-5">
          <div className="why-header-home" data-aos="fade-up" data-aos-delay="0">
            <span>Our Services</span>
            <h1>What We Offer</h1>
          </div>
          <div className="row">
            <div className="why-text1" data-aos="fade-up" data-aos-delay="100">
              <p className="right-textA">
                We provide a wide range of innovative and tailored solutions to meet your business needs. Our expertise ensures high-quality results that drive growth and success.
              </p>
            </div>
          </div>
        </div>

        <div className="service-butn">
          <a href="/servicedetail" className="cta-button">
            Explore All Services <span className="arrow">↗</span>
          </a>
        </div>
        <div className="row">
        <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay="100">
          <div className="service-card">
            <div className="service-icon"><i className="fa-regular fa-window-maximize"></i></div>
            <h3 className="service-title">Website Development Services</h3>
            <p className="service-title">We create custom, responsive, and SEO-optimized websites that boost brand presence and drive growth. Our full-stack solutions ensure high performance, engagement, and seamless experiences. From e-commerce to corporate sites, we deliver scalable, secure, and innovative web solutions. </p>
            <a href="/servicedetail" className="learn-more">LEARN MORE <i className="fa fa-solid fa-arrow-right"></i></a>
          </div>
        </div>
        <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay="200">
          <div className="service-card">
            <div className="service-icon"><i className="fa-brands fa-android"></i></div>
            <h3 className="service-title">Mobile Application Development Solution</h3>
            <p className="service-title">We develop scalable, secure, and intuitive mobile apps for iOS, Android, and cross-platform solutions. Whether you need a feature-rich Android app, an engaging iOS application, or a seamless multi-platform experience, we ensure top-tier performance and user engagement.</p>
            <a href="/servicedetail" className="learn-more">LEARN MORE <i className="fa fa-solid fa-arrow-right"></i></a>
          </div>
        </div>
        <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay="200">
          <div className="service-card">
            <div className="service-icon"><i className="fa-brands fa-instagram"></i></div>
            <h3 className="service-title">Strategic Digital Marketing Services</h3>
            <p className="service-title">Grow and engage your audience with our strategic digital marketing solutions. From content creation to targeted ad campaigns, we help you connect with the right audience, boost brand visibility, and drive meaningful engagement across social media platforms.</p>
            <a href="/servicedetail" className="learn-more">LEARN MORE <i className="fa fa-solid fa-arrow-right"></i></a>
          </div>
        </div>
        <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay="100">
          <div className="service-card">
            <div className="service-icon"><i className="fa-solid fa-bars"></i></div>
            <h3 className="service-title">Results-Driven Content Marketing</h3>
            <p className="service-title">We craft informative blogs, engaging videos, and shareable infographics designed to captivate your audience and boost website traffic. Our strategic content marketing solutions enhance brand authority, drive engagement, and maximize your online presence.</p>
            <a href="/servicedetail" className="learn-more">LEARN MORE <i className="fa fa-solid fa-arrow-right"></i></a>
          </div>
        </div>
        <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay="100">
          <div className="service-card">
            <div className="service-icon"><i className="fab fa-figma"></i></div>
            <h3 className="service-title">UI/UX & Figma Design Solutions</h3>
            <p className="service-title">Our Figma design solutions provide a seamless, collaborative, and pixel-perfect experience. We specialize in crafting intuitive UX and visually stunning UI that align with your business goals. From dynamic prototypes to responsive designs, we ensure flawless functionality and engaging user experiences.</p>
            <a href="/servicedetail" className="learn-more">LEARN MORE <i className="fa fa-solid fa-arrow-right"></i></a>
          </div>
        </div>
        <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay="200">
          <div className="service-card">
            <div className="service-icon"><i className="fas fa-code"></i></div>
            <h3 className="service-title">Custom Software Development</h3>
            <p className="service-title">Our expert team utilizes cutting-edge technologies and industry best practices to develop scalable, secure, and high-performance software solutions. Whether you're a startup or an enterprise, we provide end-to-end software development to drive innovation and keep you ahead in the digital era.
            </p>
            <a href="/servicedetail" className="learn-more">LEARN MORE <i className="fa fa-solid fa-arrow-right"></i></a>
          </div>
        </div>
      </div>
        
      </div>

      <div className="container-fluid p-3">
        <div className="text-center mb-5" data-aos="fade-up" data-aos-delay="0">
          <span className="brands">Brands Collaboration</span>
          <h2 className="mt-3 brand-trust">Trusted by Leading Brands</h2>
        </div>
        <div className="slider-container-home">
      {/* First row */}
      <div className="slider-row slider-row-left" ref={row1Ref}>
        <div className="slider-inner">
          {imagesRow1.map((src, index) => (
            <div className="slider-card" key={index}>
              <img src={src} alt="logo" />
            </div>
          ))}
        </div>
      </div>

      {/* Second row */}
      <div className="slider-row slider-row-right" ref={row2Ref}>
        <div className="slider-inner">
          {imagesRow2.map((src, index) => (
            <div className="slider-card" key={index}>
              <img src={src} alt="logo" />
            </div>
          ))}
        </div>
      </div>
    </div>
      </div>
    </section>


 
  <section className="stats-section  text-white py-5">

    <div className="container text-center">
      <div className="row justify-content-center circle-text ">
        {/* <!-- Years of Experience --> */}
        <div className="col-md-3 d-none d-md-block " data-aos="fade-up" data-aos-delay="0">
          <div className="stat-circle mx-auto d-flex flex-column align-items-center justify-content-center">
            <h2>12+</h2>
            <p>Years of Industry Experience</p>
          </div>
        </div>
        {/* <!-- Successful Projects --> */}
        <div className="col-md-3 d-none d-md-block " data-aos="fade-up" data-aos-delay="100">
          <div className="stat-circle mx-auto d-flex flex-column align-items-center justify-content-center">
            <h2>200+</h2>
            <p>Successful Projects Delivered</p>
          </div>
        </div>
        {/* <!-- Happy Clients --> */}
        <div className="col-md-3 d-none d-md-block " data-aos="fade-up" data-aos-delay="200">
          <div className="stat-circle mx-auto d-flex flex-column align-items-center justify-content-center">
            <h2>150+</h2>
            <p>Satisfied Clients</p>
          </div>
        </div>
        {/* <!-- 5 Star Reviews --> */}
        <div className="col-md-3 d-none d-md-block " data-aos="fade-up" data-aos-delay="300">
          <div className="stat-circle mx-auto d-flex flex-column align-items-center justify-content-center">
            <h2>160+</h2>
            <p>5 Star Reviews</p>
          </div>
        </div>
      </div>
    </div>
    <div className="container-fluid mt-5 ">
      <div className="row text-center text-team">
        {/* <!-- Proven Track Record --> */}
        <div className="col-md-4 mb-3" data-aos="fade-up" data-aos-delay="0">
          <div className="feature-card">
            <div className="feature-icon"><i className="fa-solid fa-rocket"></i></div>
            <h3 className="feature-title">Our Proven Track Record</h3>
            <p className="feature-description">With over 12 years of experience, we've delivered 200+ successful projects, earning the trust of 150+ satisfied clients and achieving 160 five-star reviews. Our proven track record showcases our commitment to excellence and client satisfaction.</p>
          </div>
        </div>
        <div className="col-md-4 mb-3" data-aos="fade-up" data-aos-delay="100">
          <div className="feature-card">
            <div className="feature-icon"><i className="fa-solid fa-hexagon-nodes"></i></div>
            <h3 className="feature-title">Personalized Solutions</h3>
            <p className="feature-description">We provide customized strategies tailored to your specific goals, target audience, and industry, ensuring optimal results and engagement.</p>
          </div>
        </div>
        <div className="col-md-4 mb-3" data-aos="fade-up" data-aos-delay="200">
          <div className="feature-card">
            <div className="feature-icon"><i className="fa-solid fa-users-viewfinder"></i></div>
            <h3 className="feature-title">Client-Centric Focus</h3>
            <p className="feature-description">Your success is our priority. We focus on understanding your business goals to deliver personalized solutions that meet your unique needs.</p>
          </div>
        </div>
      </div>
      <div className="row mt-4 text-center">
        <div className="col">
          <div className="d-flex justify-content-center flex-wrap gap-2">
            <span className="badge-atom rounded-pill bg-secondary py-2 px-3" data-aos="fade-up" data-aos-delay="0"><i
                className="fa-solid fa-atom"></i>Continuous Innovation</span>
            <span className="badge-atom rounded-pill bg-secondary py-2 px-3" data-aos="fade-up" data-aos-delay="100"><i
                className="fa-solid fa-atom"></i>Dedicated Support</span>
            <span className="badge-atom rounded-pill bg-secondary py-2 px-3" data-aos="fade-up" data-aos-delay="200"><i
                className="fa-solid fa-atom"></i>Positive Client Experiences</span>
            <span className="badge-atom rounded-pill bg-secondary py-2 px-3" data-aos="fade-up" data-aos-delay="300"><i
                className="fa-solid fa-atom"></i>Commitment to Excellence</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section className="case-studies-section text-white py-5">
    <div className="container-fluid case-studie-padding">
      <div className="text-center mb-5" data-aos="fade-up" data-aos-delay="0">
        <span className="brands">works</span>
        <h2 className="mt-3 brand-trust">Case Studies</h2>
      </div>
      <div className="row g-4">
        {/* <!-- Case Study 1 --> */}
        <div className="col-md-6" data-aos="fade-up" data-aos-delay="0">
          <a href="/fot" className="text-decoration-none">
          <div className="card_imageA bg-dark case-studies">
            <img src={case1} className="card-img-top" alt="Showreel"/>
          </div>
          <div className="card-body work-text">
            <span className="card-head">Case Study</span>
            <h4 className="card-title">Food Ordering App and Web</h4>
            <p className="card-text">From Idea to Execution,Execution to Completion </p>
            <div className="d-flex justify-content-between">
              <div className="work-percent">
                <h6 className="mb-0">40%</h6>
                <small>Increase in website traffic</small>
              </div>
              <div className="work-percent">
                <h6 className="mb-0">70%</h6>
                <small>Target keywords ranked</small>
              </div>
            </div>
          </div>
        </a>
        </div>
        {/* <!-- Case Study 2 --> */}
        <div className="col-md-6 case-studie" data-aos="fade-up" data-aos-delay="100">
          <a href="/dakzy" className="text-decoration-none">
          <div className="card_imageA bg-dark case-studies">
            <img src={case2} className="card-img-top" alt=""/>
          </div>
          <div className="card-body work-text">
            <span className="card-head">Case Study</span>
            <h4 className="card-title">Local Store to E-Commerce Business</h4>
            <p className="card-text">Want To Business Online Give Us Your Idea</p>
            <div className="d-flex justify-content-between">
              <div className="work-percent">
                <h6 className="mb-0">60%</h6>
                <small>Increase in organic traffic</small>
              </div>
              <div className="work-percent">
                <h6 className="mb-0">#1</h6>
                <small>Rank on Google</small>
              </div>
            </div>
          </div>
          </a>

        </div>
        {/* <!-- Case Study 3 --> */}
        <div className="col-md-6 " data-aos="fade-up" data-aos-delay="100">
          <a href="/girlsslay" className="text-decoration-none">
          <div className="card_imageA bg-dark case-studies ">
            <img src={case3} className="card-img-top" alt=""/>
          </div>
          <div className="card-body work-text">
            <span className="card-head">Case Study</span>
            <h4 className="card-title">How Girls Slay Grew Its Clientele </h4>
            <p className="card-text">Boosting client bookings through targeted digital marketing strategies</p>
            <div className="d-flex justify-content-between">
              <div className="work-percent">
                <h6 className="mb-0">30%</h6>
                <small>New client bookings</small>
              </div>
              <div className="work-percent">
                <h6 className="mb-0">50%</h6>
                <small>Local search increase</small>
              </div>
            </div>
          </div>
          </a>

        </div>
        {/* <!-- Case Study 4 --> */}
        <div className="col-md-6 case-studie" data-aos="fade-up" data-aos-delay="200">
          <a href="/myacebazar" className="text-decoration-none">
          <div className="card_imageA bg-dark case-studies">
            <img src={case4} className="card-img-top" alt=""/>
          </div>
          <div className=" card-body work-text">
            <span className="card-head">Case Study</span>
            <h4 className="card-title">One Stop Shopping solution With Easy Access</h4>
            <p className="card-text">How Tech Haven skyrocketed its online sales by 40%</p>
            <div className="d-flex justify-content-between">
              <div className="work-percent">
                <h6 className="mb-0">60%</h6>
                <small>Increase in SEO performance</small>
              </div>
              <div className="work-percent">
                <h6 className="mb-0">80%</h6>
                <small>Conversion rate</small>
              </div>
            </div>
          </div>
          </a>

        </div>
      </div>
      <div className="text-center arrow mt-5" data-aos="fade-up" data-aos-delay="0">
        
            <a href="projects" className="cta-button">
              View All Projects <span className="arrow">↗</span>
          </a>
      </div>
    </div>
  </section>

  <section className="">
    <div className="rating" data-aos="fade-up" data-aos-delay="0">
       <h2 className=" Testimonial-bg">Testimonial</h2>
      <div className="carouselA">
     

        <div className="groupA">

          <div className="testimonial-card">
            <div className="stars">
              ★★★★★
            </div>
            <p className="mt-3 text-start">
              I've been using this company's IT services for over a year, and I can confidently say their customer
              support is top-notch. Their team is always available to resolve issues quickly and professionally.
            </p>
            <hr className="line"/>
            <h5>Rajesh Sharma</h5>
            <small>CEO, TechFusion Solutions</small>
          </div>

          <div className="testimonial-card">
            <div className="stars">
              ★★★★★
            </div>
            <p className="mt-3 text-start">
              Always Reliable and Efficient. Our partnership with this IT service provider has been nothing short of
              excellent. Their team is always available to help with any technical challenges we face, and they provide
              efficient, cost-effective solutions. Their proactive approach ensures that issues are fixed before they
              even become problems.</p>
            <hr className="line"/>
            <h5>Priyank Yadav</h5>
            <small>CEO, Softwave Technologies</small>
          </div>

          <div className="testimonial-card">
            <div className="stars">
              ★★★★★
            </div>
            <p className="mt-3 text-start">
              Great Value for Money. We've been with this IT service provider for several months, and the value we've
              received for the cost is impressive. Their services are comprehensive, from software solutions to cloud
              management, and everything works flawlessly. They offer great customer service and competitive pricing
            </p>
            <hr className="line"/>
            <h5>Mohit Gupta</h5>
            <small> CTO, BrightEdge Technologies</small>
          </div>



          <div className="testimonial-card">
            <div className="stars">
              ★★★★★
            </div>
            <p className="mt-3 text-start">
              I've been using this company's IT services for over a year, and I can confidently say their customer
              support is top-notch. Their team is always available to resolve issues quickly and professionally.
            </p>
            <hr className="line"/>
            <h5>Rajesh Sharma</h5>
            <small>CEO, TechFusion Solutions</small>
          </div>

          <div className="testimonial-card">
            <div className="stars">
              ★★★★★
            </div>
            <p className="mt-3 text-start">
              Always Reliable and Efficient. Our partnership with this IT service provider has been nothing short of
              excellent. Their team is always available to help with any technical challenges we face, and they provide
              efficient, cost-effective solutions. Their proactive approach ensures that issues are fixed before they
              even become problems.</p>
            <hr className="line"/>
            <h5>Priyank Yadav</h5>
            <small>CEO, Softwave Technologies</small>
          </div>
          <div className="testimonial-card">
            <div className="stars">
              ★★★★★
            </div>
            <p className="mt-3 text-start">
              Great Value for Money. We've been with this IT service provider for several months, and the value we've
              received for the cost is impressive. Their services are comprehensive, from software solutions to cloud
              management, and everything works flawlessly. They offer great customer service and competitive pricing
            </p>
            <hr className="line"/>
            <h5>Mohit Gupta</h5>
            <small> CTO, BrightEdge Technologies</small>
          </div>


        </div>
      </div>
      <div className="text-center mt-5" data-aos="fade-up" data-aos-delay="0">
            <a href="/reviews" className="cta-button">
              View All Reviews <span className="arrow">↗</span>
          </a>
          
            
      </div>
    </div>

  </section>

  <section className="why-us container-fluid">
    <div className="why mt-5">

      <div className="why-header-home" data-aos="fade-up" data-aos-delay="0">
        <span>Why Us</span>
        <h1>Our Specialities</h1>
      </div>
      <div className="row">
        <div className="why-text1 " data-aos="fade-up" data-aos-delay="100">
          <p className="right-text">Our company not only delivers impressive results but also dazzles
            our clients with remarkable statistics. We pride ourselves on our
            ability to amaze customers with tangible outcomes and eye-catching
            figures.</p>

        </div>

      </div>
    </div>

      <div className="container-fluid">
        {/* <!-- Content Row 1 --> */}
        <div className="row why-text">
          <div className="col-lg-8 col-12 mt-3 image-padding" data-aos="fade-up" data-aos-delay="0">
            <div className="image-overlay">
            
              <div className="text-overlay Specialities-first">
                <h2>1000+</h2>
                <p>Achieved Over 1,000 Successful Digital Transformations</p>
                <div className="text-overlay1">
                  <p>Our expertise in web development, mobile app solutions, and digital marketing has helped businesses across industries digitally transform and thrive. With over 1,000 successful projects, we empower brands to innovate, scale, and stay ahead of the curve.</p>

                </div>
              </div>
              
            </div>
          </div>
          <div className="col-lg-4 col-12 box-bg mt-3" data-aos="fade-up" data-aos-delay="100">
            <div className="text-box">
              <h2>150%</h2>
              <p>Boost in User Engagement</p>
            </div>


          </div>
        </div>

        {/* <!-- Content Row 2 --> */}
        <div className="row">
          <div className="col-lg-6 col-12 mt-3 image-padding" data-aos="fade-up" data-aos-delay="0">
            

            {/* <div className="box">

              <div className="circle-container" id="circle">
                  <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Customer Support</div>
                  <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Passion</div>
                  <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Positive Experience</div>
                  <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Trustworthiness</div>
                  <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Customer Focus</div>
                  <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Long-term Relation </div>
                  <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Innovation</div>
                  <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Collaboration</div>
                  <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Personalization</div>
                  <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Reliability</div>
                  <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Quality</div>
              </div>
              </div> */}
                <div className="box_home">
      <div className="circle-container" ref={circleRef}>
        {words.map((word, index) => (
          <div key={index} className="word word-{index+1}">
            <img
              width="18"
              height="18"
              src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah.png"
              alt="icon"
            />
            {word}
          </div>
        ))}
      </div>
    </div>


          </div>
          <div className="col-lg-6 col-12 box2-home mt-3" data-aos="fade-up" data-aos-delay="100">
            <div className="box-text">
              <h2>Enhanced Brand Visibility</h2>
              <p>80%</p>
            </div>
            <p className="box-textA">With SEO, social media marketing, and tailored advertising strategies, our clients have seen an 80% improvement in brand visibility, turning businesses into household names.</p>
          </div>

        </div>

      </div>
  </section>
  <section>
    <div className="container py-5" data-aos="fade-up" data-aos-delay="0">
        <h2 className="section-title-home mb-3">Technologies We Support</h2>
        <p className="text-center">Our experts are proficient in a wide range of technologies, ensuring that you have
            the right skills for any project. Here's a snapshot of the technologies we support:</p>

        <div className="row g-4">
            {/* <!-- Backend --> */}
            <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
                <div className="tech-box">
                    <h4 className="category-title">Backend</h4>

                    <p className="tech-title">Java</p>
                    <span className="tech-pill">SE 8/11</span>
                    <span className="tech-pill">Spring</span>
                    <span className="tech-pill">Spring Boot</span>
                    <span className="tech-pill">Hibernate</span>
                    <span className="tech-pill">Liquibase</span>

                    <p className="tech-title">Python</p>
                    <span className="tech-pill">Django</span>
                    <span className="tech-pill">Flask</span>
                    <span className="tech-pill">Pyramid</span>
                    <span className="tech-pill">FastAPI</span>
                    <span className="tech-pill">Asyncio</span>

                    <p className="tech-title">C#</p>
                    <span className="tech-pill">ASP.NET Core/EF</span>
                    <span className="tech-pill">MediatR</span>
                    <span className="tech-pill">AutoMapper</span>
                    <span className="tech-pill">Serilog/XUnit</span>
                    <span className="tech-pill">Moq</span>

                    <p className="tech-title">PHP</p>
                    <span className="tech-pill">Laravel</span>
                    <span className="tech-pill">Symfony</span>
                    <span className="tech-pill">Yii2</span>
                    <span className="tech-pill">Bitrix</span>

                    <p className="tech-title">Go</p>
                    <span className="tech-pill">Revel</span>
                    <span className="tech-pill">Beego</span>
                    <span className="tech-pill">Gin</span>
                    <span className="tech-pill">Buffalo</span>
                    <span className="tech-pill">Kit</span>
                    <span className="tech-pill">Echo</span>

                    <p className="tech-title">Ruby</p>
                    <span className="tech-pill">Ruby on Rails</span>
                    <span className="tech-pill">Sinatra</span>
                    <span className="tech-pill">Hanami (Lotus)</span>

                    <p className="tech-title">C++</p>
                    <span className="tech-pill">CRYEngine</span>
                    <span className="tech-pill">LumberYard</span>
                    <span className="tech-pill">UE4</span>
                    <span className="tech-pill">Tensorflow</span>
                    <span className="tech-pill">Pytorch</span>
                    <span className="tech-pill">Geometric tools</span>
                    <span className="tech-pill">Cgal</span>
                    <span className="tech-pill">MeshLabDDS/MQTT</span>
                    <span className="tech-pill">TCP</span>
                    <span className="tech-pill">UDP</span>
                    <span className="tech-pill">POCO</span>
                    <span className="tech-pill">OSP</span>
                    <span className="tech-pill">Linux</span>
                    <span className="tech-pill">Windows</span>
                    <span className="tech-pill">VXWorks</span>

                    <p className="tech-title">DB</p>
                    <span className="tech-pill">PostgreSQL</span>
                    <span className="tech-pill">Oracle</span>
                    <span className="tech-pill">MS SQL</span>
                    <span className="tech-pill">MongoDB</span>
                    <span className="tech-pill">Redis</span>
                    <span className="tech-pill">Elasticsearch</span>


                </div>
            </div>

            {/* <!-- Frontend --> */}
            <div className=" col-md-6" data-aos="fade-up" data-aos-delay="0">
                <div className="row">

                    <div className="col-md-12" data-aos="fade-up" data-aos-delay="100">
                        <div className="tech-box">
                            <h5 className="category-title">Frontend</h5>
                            <span className="tech-pill">JavaScript</span>
                            <span className="tech-pill">TypeScript</span>
                            <span className="tech-pill">React</span>
                            <span className="tech-pill">Redux</span>
                            <span className="tech-pill">Vue.js</span>
                            <span className="tech-pill">Angular</span>
                            <span className="tech-pill">Node.js</span>
                            <span className="tech-pill">Next.js</span>
                            <span className="tech-pill">Docker</span>
                        </div>
                    </div>

                    {/* <!-- Mobile --> */}
                    <div className="col-md-12 mt-5" data-aos="fade-up" data-aos-delay="200">
                        <div className="tech-box">
                            <h5 className="category-title">Mobile</h5>
                            <span className="tech-pill">iOS</span>
                            <span className="tech-pill">Swift</span>
                            <span className="tech-pill">CoreData</span>
                            <span className="tech-pill">RxSwift</span>
                            <span className="tech-pill">Android</span>
                            <span className="tech-pill">Kotlin</span>
                            <span className="tech-pill">MVVM</span>
                            <span className="tech-pill">Retrofit</span>
                            <span className="tech-pill">Flutter</span>
                            <span className="tech-pill">React Native</span>
                        </div>
                    </div>
                    <div className="col-md-12 mt-5" data-aos="fade-up" data-aos-delay="300">
                        <div className="tech-box">
                            <h5 className="category-title">QA</h5>
                            <span className="tech-pill">Selenium</span>
                            <span className="tech-pill">Postman</span>
                            <span className="tech-pill">Swagger</span>
                            <span className="tech-pill">JMeter</span>
                            <span className="tech-pill">TestRail</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* <!-- QA --> */}


            {/* <!-- DevOps --> */}
            <div className="col-md-6 " data-aos="fade-up" data-aos-delay="100">
                <div className="tech-box">
                    <h5 className="category-title">DevOps</h5>
                    <span className="tech-pill">Kubernetes</span>
                    <span className="tech-pill">Terraform</span>
                    <span className="tech-pill">Ansible</span>
                    <span className="tech-pill">Jenkins</span>
                    <span className="tech-pill">Docker</span>
                </div>
            </div>

            {/* <!-- Other --> */}
            <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                <div className="tech-box">
                    <h5 className="category-title">Other</h5>
                    <span className="tech-pill">REST</span>
                    <span className="tech-pill">SOAP</span>
                    <span className="tech-pill">GraphQL</span>
                    <span className="tech-pill">JSON</span>
                    <span className="tech-pill">CI/CD</span>
                </div>
            </div>

        </div>
    </div>
</section>

  <section className="container-fluid ">
    <div className="main-blog  mt-5">
      <div className="blog">
        {/* <!-- Header --> */}
        <div className="why-header-home aos-init aos-animate" data-aos="fade-up" data-aos-delay="0">
        <span>Blogs</span>
        </div>
        <div className="blog-header">
          <h1>Dive into our collection of engaging blog posts</h1>
        </div>

        {/* <!-- Read Blogs Button --> */}
        <div className="read-blogs">
           
          <a href="/blog" className="cta-button">
            Read Blogs <span className="arrow">↗</span>
        </a>
        </div>
      </div>

     
      
      
       <div className="row g-4  mt-5">
        {/* <!-- Blog Card --> */}
        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="0">
          <a href="/blog" className="text-decoration-none">
          <div className="blog-card">
            {/* <!-- Badges --> */}
            <div className="blog-badges">
              <button className="blog-badge"><i className="fa-solid fa-star"></i>FEATURED</button>
              <button className="blog-badge"><i className="fa-solid fa-calendar"></i>FEB 7, 2024</button>
              <button className="blog-badge"><i className="fa-solid fa-clipboard"></i>NEWS</button>
            </div>
            {/* <!-- Image --> */}
            <img src={blog1} alt="Blog about technology and trends" />

          </div>
          {/* <!-- Content --> */}
          <div className="blog-content">
            <p>"The Future of IT Services: Trends to Watch in 2024"</p>
          </div>
          </a>
        </div>

        {/* <!-- Additional Blog Cards --> */}
        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
          <a href="/blog" className="text-decoration-none">
          <div className="blog-card">
            {/* <!-- Badges --> */}
            <div className="blog-badges">
              <button className="blog-badge"><i className="fa-solid fa-calendar"></i>FEB 7, 2024</button>
              <button className="blog-badge"><i className="fa-solid fa-clipboard"></i>Article</button>
            </div>
            {/* <!-- Image --> */}
            <img
              src={blog2}  alt="Blog about technology and trends"/>
          </div>
          {/* <!-- Content --> */}
          <div className="blog-content">
            <p>"Navigating the Marketplace for SEO: Finding the Right Solutions for Your Business"</p>
          </div>
          </a>
        </div>

        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
          <a href="/blog" className="text-decoration-none">
          <div className="blog-card">
            {/* <!-- Badges --> */}
            <div className="blog-badges">
              <button className="blog-badge"><i className="fa-solid fa-calendar"></i>FEB 7, 2024</button>
              <button className="blog-badge"><i className="fa-solid fa-clipboard"></i>NEWS</button>
            </div>
            {/* <!-- Image --> */}
            <img
              src={blog3} alt="Blog about technology and trends"/>
          </div>
          {/* <!-- Content --> */}
          <div className="blog-content">
            <p>"Empower Your SEO Strategy with Top SEO Tools: A Comprehensive Guide"</p>
          </div>
          </a>
        </div>
       
 

      </div>
     </div>
  </section>

   
      <section className="accordion-bg">
      <div className="text-center mb-5" data-aos="fade-up">
        <span className="brands">Frequently Asked Questions</span>
      </div>
      <div className="accordion-section" data-aos="fade-up">
        <h1>
          Got Questions <br/> We've Got Answers!
        </h1>
      </div>

      {faqData.map((item, index) => (
        <div key={index}
          className={`accordion ${activeIndex === index ? "active" : ""}`}
         >
          <div className="accordion-header" onClick={() => toggleAccordion(index)}>
            <h3>{item.question}</h3>
            <div className="caret-box">
              <FaChevronDown
                className={`caret ${activeIndex === index ? "rotate" : ""}`}/>
            </div>
          </div>
          <div className="accordion-content"
            style={{ maxHeight: activeIndex === index ? "150px" : "0" }}>
            <p>{item.answer}</p>
          </div>
        </div>
      ))}
    </section>


  <section className="loction-text">
    <div className="card-container-location container">
        <div className="row justify-content-center">
            <div className="col-lg-2 col-md-4 col-sm-6 col-6">
                <div className="card-location" data-aos="fade-up" data-aos-delay="600">
                    <div className="icon-location">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/>
                        </svg>
                    </div>
                    <h3>India</h3>
                    <p>301, 3rd floor 244-245, Dhruv marg, Tilak Nagar, Jaipur</p>
                    <p>+91-8949687368</p>
                </div>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6 col-6">
                <div className="card-location" data-aos="fade-up" data-aos-delay="400">
                    <div className="icon-location">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/>
                        </svg>
                    </div>
                    <h3>India</h3>
                    <p>01, 1st floor Malhar Megha mall, Indore</p>
                    <p>+91-9826096345</p>
                </div>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6 col-6">
                <div className="card-location" data-aos="fade-up" data-aos-delay="200">
                    <div className="icon-location">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/>
                        </svg>
                    </div>
                    <h3>UK</h3>
                    <p>10 Carey St, Reading, Berkshire, RG1 7JS, UK</p>
                    <p>+44-7966 002800</p>
                </div>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6 col-6">
                <div className="card-location" data-aos="fade-up" data-aos-delay="400">
                    <div className="icon-location">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/>
                        </svg>
                    </div>
                    <h3>Dubai</h3>
                    <p>Building 02 8th floor, Business Bay, Dubai, UAE</p>
                    <p>+971-43799055</p>
                </div>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6 col-6">
                <div className="card-location" data-aos="fade-up" data-aos-delay="600">
                    <div className="icon-location">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/>
                        </svg>
                    </div>
                    <h3>Canada</h3>
                    <p>7390 Inverness Street, Vancouver, BC V5X 4H1, Canada</p>
                    <p>+1-6049062982</p>
                </div>
            </div>
        </div>
    </div>
</section>

   

    </div>
  )
}

export default Homes;
